import React from 'react';
import { useTheme } from '@/hooks/useTheme';

// Import logos with proper dark/light variants
import logoDark from '@/assets/FiveLogo_black.png';
import logoWhite from '@/assets/FiveLogo_white.png';
import fiveLogoLight from '@/assets/five-logo.png';
import fiveIcon from '@/assets/five-icon.png';

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon' | 'footer';
}

export const Logo: React.FC<LogoProps> = ({ className = '', variant = 'full' }) => {
  const { theme } = useTheme();

  // Determine which logo to use based on variant and theme
  let logoSrc: string;
  
  if (variant === 'footer') {
    // For footer, use five-logo or white variant for dark mode
    if (theme === 'dark') {
      // Use white logo for dark mode footer
      logoSrc = logoWhite;
    } else {
      logoSrc = fiveLogoLight;
    }
  } else if (variant === 'icon') {
    // For icon, always use the same (icon doesn't need dark variant)
    logoSrc = fiveIcon;
  } else {
    // For full logo (header/hero)
    if (theme === 'dark') {
      // Use white logo for dark mode (white text on dark background)
      logoSrc = logoWhite;
    } else {
      // Use dark logo for light mode (dark text on light background)
      logoSrc = logoDark;
    }
  }

  return (
    <img
      src={logoSrc}
      alt="Five AI"
      className={className}
    />
  );
};
